"use strict";

exports.__esModule = true;
exports.updatePlantStateActivitiesDevicesWithFormData = updatePlantStateActivitiesDevicesWithFormData;
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
/** Given some form data, update the plant state activities data with the modified values */
function updatePlantStateActivitiesDevicesWithFormData(formData, _ref) {
  var activitiesDevices = _ref.activitiesDevices;
  var formActivity = Object.assign({}, (_objectDestructuringEmpty(formData), formData));
  var newActivitiesDevices = activitiesDevices.filter(function (a) {
    return a.id !== formData.id;
  });
  newActivitiesDevices.unshift({
    id: formActivity.id,
    devices: formData.selectedDevices
  });
  activitiesDevices = newActivitiesDevices;
  return {
    activitiesDevices: activitiesDevices
  };
}